import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Hero from "./components/Hero";
import ExpertiseBand from "./components/ExpertiseBand";
import About from "./components/About";
import Practice from "./components/Practice";
import Process from "./components/Process";
import Press from "./components/Press";
import Cases from "./components/Cases";
import Center from "./components/Center";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Quote from "./components/Quote";

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <ExpertiseBand />
        <About />
        <Practice />
        <Process />
        <Quote />
        <Press />
        <Cases />
        <Center />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  );
}